import { makeAppConfigStore } from '@frontend/app-config-store';
import { paymentsSentry } from '@frontend/payments-hooks';

export const useWeavePayAppConfigStore = makeAppConfigStore({
  uniqueStoreName: 'payAppConfigStore',
  config: [
    {
      key: 'IS_PREVIEW',
      required: false,
    },
    {
      key: 'PAY_BACKEND_API',
      default: 'https://api.weaveconnect.com',
      alertIfDefaultUsed: true,
    },
    {
      key: 'STRIPE_EXPRESS_TEST_API_KEY',
    },
    {
      key: 'PAY_SENTRY_DSN',
      default: 'https://7fd7f754b24d49f3b030eb9b88d986b2@o339352.ingest.us.sentry.io/4504770579005440',
      alertIfDefaultUsed: true,
    },
  ],
  handleMissingValue: (key) => {
    console.error(`Missing value for config key: ${key}`);
    paymentsSentry.error('WeavePayAppConfig missing config value: ' + key, 'WeavePayAppConfig', `Key: ${key}`);
  },
  handleDefaultUsed: (key, value) => {
    console.warn(`Default value used for config key: ${key}, value: ${value}`);
    paymentsSentry.log('WeavePayAppConfig default value used for config key: ' + key, { key, value });
  },
});
